'use strict';
import s from "../external/base-64/base64.js";
import { getUserToken as r } from "./getUserId.js";
function c() {
  const o = r(), e = new Headers();
  return e.set(
    "X-API-Key",
    s.encode(
      `${process.env.NEXT_PUBLIC_RESTFUL_USER}:${process.env.NEXT_PUBLIC_RESTFUL_KEY}`
    )
  ), o && e.set("Authorization", `Bearer ${o}`), e.set("Content-Type", "application/json"), e;
}
export {
  c as getHeaders
};
